import type { Cohort } from '@efdigital/ll-addon-data';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CohortListingSignature {
  Args: {
    cohort: Cohort;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

function formatDate(date: string) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export const CohortListing: TemplateOnlyComponent<CohortListingSignature> =
  <template>
    <div class="card" ...attributes>
      {{#if @cohort.icon}}
        <img src={{@cohort.icon}} alt={{@cohort.title}} class="card-img-top" />
      {{/if}}
      <div class="card-body">
        <h3 class="card-title h5">{{@cohort.title}}</h3>
        {{#if @cohort.abstract}}
          <p class="card-text">{{@cohort.abstract}}</p>
        {{/if}}
        {{#if @cohort.starts}}
          <div class="text-muted">
            <small>Starts:
              {{formatDate @cohort.starts}}</small>
          </div>
        {{/if}}
      </div>
      {{#if (has-block)}}
        <div class="card-footer">
          {{yield}}
        </div>
      {{/if}}
    </div>
  </template>;
